import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import DefaultLayout from './DefaultLayout';
import { getSubscriptionStatus, subscribeToNotifications } from '@/redux/reducers/appReducer';

const mapStateToProps = createStructuredSelector({
  subscriptionStatus: getSubscriptionStatus,
});

const mapDispatchToProps = {
  subscribeToNotifications,
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);
